import Vue from "vue";
import Vuex from "vuex";
import jwt from "jsonwebtoken";
import router from "@/router";
import { Prefecture } from "../interfaces/prefecture";
import { PublishmentRegion } from "@/interfaces/publishmentregion";
import { PublishmentLocality } from "@/interfaces/publishmentlocality";
import { PublishmentCourse } from "@/interfaces/publishmentcourse";
import { HeaderProcess } from "@/plugins/HeaderProcess";
import JwtTokenObject from "@/interfaces/jwttokenobject";
import Api from "@/api/Api";

Vue.use(Vuex);

// const API_ENDPOINT = "";
const api = Api.singleton();
export default new Vuex.Store<{
  // jwtToken?: JwtTokenObject | null;
  // jwtTokenString?: string;
  document?: string;
  prefectures?: Prefecture[];
  regions: PublishmentRegion[];
  localities: PublishmentLocality[];
  courses: PublishmentCourse[];
  isRefreshingSuspended: boolean;
  resourceCaches: Record<string, Array<(arg0: unknown) => void> | object>;
  headerProcess?: HeaderProcess;
}>({
  state: {
    // jwtToken: undefined,
    // jwtTokenString: undefined,
    document: "",
    prefectures: undefined,
    regions: [],
    localities: [],
    courses: [],
    isRefreshingSuspended: false,
    resourceCaches: {},
    headerProcess: undefined
  },
  mutations: {
    // setJwtToken(state, token: string) {
    //   state.jwtTokenString = token;
    //   state.jwtToken = jwt.decode(token) as JwtTokenObject;
    // },
    // clearJwtToken(state) {
    //   state.jwtTokenString = undefined;
    //   state.jwtToken = undefined;
    // },
    updateDocument(state, document: string) {
      state.document = document;
    },
    setPrefectures(state, prefectures: Prefecture[]) {
      state.prefectures = prefectures;
    },
    setRegions(state, regions: PublishmentRegion[]) {
      state.regions = regions;
    },
    setLocalities(state, localities: PublishmentLocality[]) {
      state.localities = localities;
    },
    setCourses(state, courses: PublishmentCourse[]) {
      state.courses = courses;
    },
    resumeRefreshToken(state) {
      state.isRefreshingSuspended = false;
    },
    suspendRefreshToken(state) {
      state.isRefreshingSuspended = true;
    },
    updateResourceCache(state, { id, value }) {
      state.resourceCaches[id] = value;
    },
    appendResolverToCache(state, { id, resolve }) {
      if (Array.isArray(state.resourceCaches[id])) {
        (state.resourceCaches[id] as Array<unknown>).push(
          resolve as (arg0: unknown) => void
        );
      }
    },
    setHeaderProcess(state, headerProcess: HeaderProcess) {
      state.headerProcess = headerProcess;
    }
  },
  actions: {
    updateHeaderProcess(context, headerProcess: HeaderProcess) {
      context.commit("setHeaderProcess", headerProcess);
    },
    // async fetch(context, [url, headers]: [string, Record<string, string>]) {
    //   headers = headers || {};
    //   headers["Content-Type"] = "application/json";
    //   return fetch(API_ENDPOINT + url, headers);
    // },
    async uploadFile(context, file) {
      // await context.dispatch("tryLoadJwtToken");
      // const body = new FormData();
      // body.append("file", file);
      return await api.uploadFile(file);
      // const res = await fetch(API_ENDPOINT + "/api/adv/media_objects", {
      //   method: "POST",
      //   headers: {
      //     Authorization: context.state.jwtTokenString
      //       ? "Bearer " + context.state.jwtTokenString
      //       : ""
      //   },
      //   body: body,
      //   credentials: "same-origin"
      // });
      // return await res.json();
    },
    // async tryLoadJwtToken(context) {
    //   if (context.state.isRefreshingSuspended) {
    //     return;
    //   }
    //   if (
    //     context.state.jwtTokenString &&
    //     context.state.jwtToken &&
    //     context.state.jwtToken.exp - 60 > Date.now() / 1000
    //   ) {
    //     return;
    //   }

    //   if (!localStorage.refreshToken) {
    //     return;
    //   }
    //   // リフレッシュする
    //   try {
    //     await context.dispatch("refreshToken", [localStorage.refreshToken]);
    //   } catch (e) {
    //     context.commit("suspendRefreshToken");
    //     alert(e as string);
    //     router.replace({ name: "Login" });
    //   }
    // },
    // async refreshToken(context, [refreshToken]) {
    //   const response = await fetch(
    //     API_ENDPOINT + "/api/authentication_token/refresh",
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json"
    //       },
    //       body: JSON.stringify({
    //         ["refresh_token"]: refreshToken
    //       }),
    //       credentials: "same-origin"
    //     }
    //   );
    //   if (!response.ok) {
    //     throw "一定時間経過したためログアウトしました";
    //   }
    //   const ret = await response.json();
    //   context.commit("setJwtToken", ret.token);
    //   context.dispatch("saveRefreshToken", ret.refresh_token);
    // },
    // async saveRefreshToken(contect, refreshToken) {
    //   localStorage.refreshToken = refreshToken;
    // },
    async reloadResource(context, id) {
      if ("" + id !== id) {
        id = id["@id"];
      }
      if (!id) {
        return;
      }
      context.commit("updateResourceCache", { id, value: null });
      return context.dispatch("loadResource", id);
    },
    async loadResource(context, id) {
      if ("" + id !== id) {
        id = id["@id"];
      }
      if (!id) {
        return;
      }
      if (!context.state.resourceCaches[id]) {
        context.commit("updateResourceCache", { id, value: [] });

        const obj = await api.call({ method: "get", resource: id });
        for (const r of context.state.resourceCaches[id] as Array<Function>) {
          r(obj);
        }
        context.commit("updateResourceCache", { id, value: obj });

        return obj;
      } else {
        if (Array.isArray(context.state.resourceCaches[id])) {
          // is an array of promise resolvers
          return await new Promise(resolve => {
            context.commit("appendResolverToCache", { id, resolve });
          });
        } else {
          return context.state.resourceCaches[id];
        }
      }
    },
    async put(context, [resource, body]: [string, {}]) {
      return await api.call({
        method: "PUT",
        resource,
        body
      });
    },
    async patch(context, [resource, body]: [string, {}]) {
      return await api.call({
        method: "PATCH",
        resource,
        body
      });
    },
    async post(context, [resource, body]: [string, {}]) {
      return await api.call({
        method: "POST",
        resource,
        body
      });
    },
    async delete(context, [resource]: [string, {}]) {
      return await api.call({
        method: "DELETE",
        resource
      });
    },
    async get(context, [resource, query = {}]: [string, {}]) {
      return await api.call({
        method: "GET",
        resource,
        query
      });
    },
    async login(context, params: object) {
      const response = await fetch("/api/authentication_token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(params),
        credentials: "same-origin"
      });
      const ret = await response.json();

      api.jwtToken.isRefreshingSuspended = false;
      api.jwtToken.setJwtToken(ret.token);
      api.jwtToken.saveRefreshToken(ret.refresh_token);
    },
    async logout(context /*, params: any*/) {
      api.jwtToken.saveRefreshToken(undefined);
      api.jwtToken.saveImpersonatedRefreshToken(undefined);
      api.jwtToken.clearJwtToken();
      api.jwtToken.clearImpersonatedJwtToken();
    },
    async unimpersonate() {
      await api.jwtToken.saveImpersonatedRefreshToken(undefined);
      api.jwtToken.clearImpersonatedJwtToken();
    },
    async fetchPrefectures(context) {
      if (context.state.prefectures) {
        return;
      }
      const ret = await this.dispatch("get", ["/api/adv/prefectures"]);
      context.commit("setPrefectures", ret["hydra:member"]);
    },
    async loadRegions(context) {
      context.commit(
        "setRegions",
        (await this.dispatch("get", ["/api/adv/publishment_regions"]))[
          "hydra:member"
        ]
      );
    },
    async loadLocalities(context) {
      context.commit(
        "setLocalities",
        (
          await this.dispatch("get", [
            "/api/adv/publishment_localities",
            {
              "order[region.id]": "asc",
              "order[id]": "asc"
            }
          ])
        )["hydra:member"]
      );
    },
    async loadCourses(context) {
      context.commit(
        "setCourses",
        (await this.dispatch("get", ["/api/adv/publishment_courses"]))[
          "hydra:member"
        ]
      );
    }
  },
  getters: {
    isGranted() {
      return (roles: string[]) => {
        return api.jwtToken.isGranted(roles);
      };
    },
    my(state, getters) {
      return () => {
        const my: { [key: string]: string | undefined } = {};
        const jwtToken = api.jwtToken;
        const jwtTokenObject = jwtToken.currentTokenObject;
        if (jwtToken.isGranted(["ROLE_ADVERTISER"])) {
          my.advertiserId = ((jwtTokenObject || {}).advertiser || {}).id;
          my.advertiser = my.advertiserId
            ? "/api/adv/clients/" + ((jwtTokenObject || {}).advertiser || {}).id
            : undefined;
        }

        if (jwtToken.isGranted(["ROLE_ADMINISTRATOR"])) {
          my.administratorId = ((jwtTokenObject || {}).administrator || {}).id;
          my.administrator = my.administratorId
            ? "/api/adv/administrators/" +
              ((jwtTokenObject || {}).administrator || {}).id
            : undefined;
        }

        return my;
      };
    },
    impersonator(state, getters) {
      return () => {
        const my: { [key: string]: string | undefined } = {};
        const jwtToken = api.jwtToken;
        if (!jwtToken.isGranted(["ROLE_IMPERSONATOR"])) {
          return {};
        }
        const jwtTokenObject = jwtToken.jwtTokenObject;

        if (jwtToken.isImpersonatorGranted(["ROLE_ADMINISTRATOR"])) {
          my.administratorId = ((jwtTokenObject || {}).administrator || {}).id;
          my.administrator = my.administratorId
            ? "/api/adv/administrators/" +
              ((jwtTokenObject || {}).administrator || {}).id
            : undefined;
        }

        return my;
      };
    }
  },
  modules: {}
});
